// extracted by mini-css-extract-plugin
export default {"img":"MobileBackground_img__8g7E6"};